/**
 * Sleep Mask Custom Product Template JavaScript
 * 100% Theme-Native Variant Integration + Hover Label Preview + Add to Cart Dynamic Price Sync
 */

(function () {
  'use strict';


  function initSleepMaskSwatches() {
    const pickers = document.querySelectorAll('.sm-color-picker');
    pickers.forEach((picker) => {
      const colorLabel = picker.querySelector('.sm-selected-color-name');
      const items = picker.querySelectorAll('.sm-swatch-item');
      if (!colorLabel || !items.length) return;

      function getSelectedName() {
        const checkedInput = picker.querySelector('.sm-native-swatch-input:checked');
        return checkedInput ? (checkedInput.getAttribute('data-color-name') || checkedInput.value) : (colorLabel.getAttribute('data-selected-name') || colorLabel.textContent.trim());
      }

      items.forEach((item) => {
        const input = item.querySelector('.sm-native-swatch-input');
        const label = item.querySelector('.sm-swatch-button');
        const colorName = input ? (input.getAttribute('data-color-name') || input.value) : label?.getAttribute('data-color-name');

        if (label && colorName) {
          label.addEventListener('mouseenter', () => {
            colorLabel.textContent = colorName;
          });

          label.addEventListener('mouseleave', () => {
            colorLabel.textContent = getSelectedName();
          });

          label.addEventListener('focus', () => {
            colorLabel.textContent = colorName;
          });

          label.addEventListener('blur', () => {
            colorLabel.textContent = getSelectedName();
          });
        }

        if (input) {
          input.addEventListener('change', () => {
            picker.querySelectorAll('.sm-swatch-button').forEach((b) => b.classList.remove('is-active'));
            if (label) label.classList.add('is-active');
            colorLabel.setAttribute('data-selected-name', colorName);
            colorLabel.textContent = colorName;
            setTimeout(syncButtonPrice, 100);
            setTimeout(syncButtonPrice, 300);
          });
        }
      });
    });

    // Option pills
    const pillGroups = document.querySelectorAll('.sm-option-group');
    pillGroups.forEach((group) => {
      const inputs = group.querySelectorAll('.sm-native-pill-input');
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          group.querySelectorAll('.sm-pill-btn').forEach((btn) => btn.classList.remove('is-selected'));
          const currentLabel = group.querySelector(`label[for="${input.id}"]`);
          if (currentLabel) currentLabel.classList.add('is-selected');
          setTimeout(syncButtonPrice, 100);
          setTimeout(syncButtonPrice, 300);
        });
      });
    });
  }

  function initSleepMaskQuantity() {
    const qtyWrappers = document.querySelectorAll('.sm-qty-wrapper');
    qtyWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector('.sm-qty-input');
      const minusBtn = wrapper.querySelector('.sm-qty-minus');
      const plusBtn = wrapper.querySelector('.sm-qty-plus');
      if (!input) return;

      if (minusBtn) {
        minusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      input.addEventListener('change', () => {
        const form = wrapper.closest('.sleep-mask-scope')?.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          let formQty = form.querySelector('input[name="quantity"]');
          if (!formQty) {
            formQty = document.createElement('input');
            formQty.type = 'hidden';
            formQty.name = 'quantity';
            form.appendChild(formQty);
          }
          formQty.value = input.value;
        }
      });
    });
  }

  function initSleepMaskUGC() {
    const ugcCards = document.querySelectorAll('.sm-ugc-card');
    if (!ugcCards.length) return;

    ugcCards.forEach((card) => {
      const video = card.querySelector('.sm-ugc-video');
      const overlay = card.querySelector('.sm-ugc-play-overlay');
      const poster = card.querySelector('.sm-ugc-poster');
      if (!video || !overlay) return;

      overlay.addEventListener('click', () => {
        ugcCards.forEach((otherCard) => {
          if (otherCard !== card) {
            const otherVideo = otherCard.querySelector('.sm-ugc-video');
            const otherPoster = otherCard.querySelector('.sm-ugc-poster');
            if (otherVideo && !otherVideo.paused) {
              otherVideo.pause();
              otherCard.classList.remove('is-playing');
              if (otherPoster) otherPoster.classList.remove('is-hidden');
            }
          }
        });

        if (video.paused) {
          video.play().then(() => {
            card.classList.add('is-playing');
            if (poster) poster.classList.add('is-hidden');
          }).catch((err) => {
            console.warn('Playback prevented:', err);
          });
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
        if (poster) poster.classList.remove('is-hidden');
      });
    });
  }

  function initSleepMaskAccordions() {
    const accordionItems = document.querySelectorAll('.sm-accordion-item');
    accordionItems.forEach((item) => {
      const header = item.querySelector('.sm-accordion-header');
      if (!header) return;

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        header.setAttribute('aria-expanded', String(!isOpen));
      });

      header.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          header.click();
        }
      });
    });
  }

  function initSleepMaskRecommendations() {
    const sliders = document.querySelectorAll('[data-rec-slider]');
    sliders.forEach((slider) => {
      const track = slider.querySelector('.sm-recommendations-track');
      const thumb = slider.querySelector('.sm-rec-scroll-thumb');
      const scrollbar = slider.querySelector('.sm-rec-scrollbar');
      if (!track) return;

      if (thumb && scrollbar) {
        function updateScrollbar() {
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (maxScroll <= 0) {
            scrollbar.style.display = 'none';
            return;
          }
          scrollbar.style.display = 'block';

          const visibleRatio = track.clientWidth / track.scrollWidth;
          const thumbWidth = Math.max(scrollbar.clientWidth * visibleRatio, 40);
          thumb.style.width = thumbWidth + 'px';

          const scrollRatio = track.scrollLeft / maxScroll;
          const maxTranslate = scrollbar.clientWidth - thumbWidth;
          thumb.style.transform = `translateX(${scrollRatio * maxTranslate}px)`;
        }

        track.addEventListener('scroll', updateScrollbar, { passive: true });
        window.addEventListener('resize', updateScrollbar, { passive: true });
        updateScrollbar();
      }
    });
  }

  function init() {
    initSleepMaskSwatches();
    initSleepMaskQuantity();
    initSleepMaskUGC();
    initSleepMaskAccordions();
    initSleepMaskRecommendations();
    syncButtonPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
